<template>
  <div class="category-chips">
    <div class="chip-row">
      <div class="chip" :class="{ active: activeId === null }" @click="selectParent(null, null)">全部</div>
      <div v-for="item in categories" :key="item.id"
           class="chip" :class="{ active: activeId === item.id }"
           @click="selectParent(item.id)">{{ item.name }}</div>
    </div>
    <div v-if="childChips.length" class="chip-row sub-row">
      <div class="chip sub" :class="{ active: activeId === activeParentId && activeChildId === null }"
           @click="$emit('select-child', { parentId: activeParentId, childId: null })">全部{{ activeParentName }}</div>
      <div v-for="child in childChips" :key="child.id"
           class="chip sub" :class="{ active: activeChildId === child.id }"
           @click="$emit('select-child', { parentId: activeParentId, childId: child.id })">{{ child.name }}</div>
    </div>
  </div>
</template>

<script>
  /**
   * 二级分类导航（方案A 两行布局）：
   * 一级 chips + 选中一级时展开二级子 chips；点一级保持其已选二级，点"全部"清除
   */
  export default {
    name: 'CategoryChips',
    props: {
      categories: { type: Array, default: () => [] },
      activeId: { type: [Number, String], default: null },
      activeChildId: { type: [Number, String], default: null }
    },
    computed: {
      activeParentId() {
        return this.activeId
      },
      activeParentName() {
        const hit = this.categories.find(c => c.id === this.activeId)
        return hit ? hit.name : ''
      },
      childChips() {
        if (this.activeId === null) {
          return []
        }
        const hit = this.categories.find(c => c.id === this.activeId)
        return hit ? (hit.children || []) : []
      }
    },
    methods: {
      selectParent(parentId) {
        this.$emit('select', parentId)
      }
    }
  }
</script>

<style scoped>
  .category-chips {
    flex-shrink: 0;
  }
  .chip-row {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    gap: 8px;
    padding: 4px 0;
  }
  .chip {
    flex-shrink: 0;
    padding: 4px 14px;
    border: 1px solid #e8e8e8;
    border-radius: 16px;
    background: #fff;
    color: #555;
    font-size: 13px;
    cursor: pointer;
    user-select: none;
  }
  .chip.active {
    background: #0081ff;
    border-color: #0081ff;
    color: #fff;
  }
  .sub-row .chip {
    padding: 2px 12px;
    font-size: 12px;
    border-radius: 12px;
    background: #f5f5f5;
  }
</style>
